import React from 'react'
import { Modal, type ModalProps } from '@chakra-ui/react'


const Component = React.forwardRef((props: ModalProps, ref: React.Ref<any>) => {
  return (
    <Modal scrollBehavior='inside' {...props}></Modal>
  )
})


export {
  Component as Modal,
  type ModalProps,
}